/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Text_To_Audio_Unsaved_TitleInputs */

const en_dialog_text_to_audio_unsaved_title = /** @type {(inputs: Dialog_Text_To_Audio_Unsaved_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unsaved text`)
};

const es_dialog_text_to_audio_unsaved_title = /** @type {(inputs: Dialog_Text_To_Audio_Unsaved_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto sin guardar`)
};

/**
* | output |
* | --- |
* | "Unsaved text" |
*
* @param {Dialog_Text_To_Audio_Unsaved_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_text_to_audio_unsaved_title = /** @type {((inputs?: Dialog_Text_To_Audio_Unsaved_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Text_To_Audio_Unsaved_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_text_to_audio_unsaved_title(inputs)
	return en_dialog_text_to_audio_unsaved_title(inputs)
});